module.exports = __webpack_public_path__ + "img/li.66fd171f.png";